import { isEmpty } from 'lodash';
import {
  deploymentValuesMap,
  metricTypeMapping,
} from '@src/emp-3.0/components/DeploymentDrawer/constants';

export function isCustomDimensionRelatedMappedEventNames(field: string) {
  return field === 'mapped_event_names';
}

export function isValueEmpty(value) {
  if (typeof value === 'number' || typeof value === 'boolean') return false;
  return isEmpty(value);
}

export function isNotNullOrUndefined(value: any) {
  return value !== null && value !== undefined;
}

export function getValue(obj, key) {
  return obj?.[key] ?? obj?.definition?.[key] ?? obj?.definition?.distribution?.[key];
}

// Such as: ['within_range', 'within_unit'], ['min_value', 'max_value']
export function getOverallDiffValues(obj, keys: string[]) {
  return keys.map((key) => getValue(obj, key)).filter((value) => value !== undefined);
}

const convertToString = (field: string, value: any): string => {
  if (['numerator', 'denominator'].includes(field)) {
    if (!value) {
      return '';
    }
    const { calculation, attribute, event, used_metric, fixed_number } = value;
    if (used_metric) {
      return used_metric;
    } else if (event) {
      return `Calculate the ${deploymentValuesMap[calculation] ?? calculation} of ${
        attribute ? attribute : event
      }${attribute ? ' for ' + event : ''}`;
    } else if (fixed_number) {
      return fixed_number.toString();
    }
    return '';
  }
  return value as string;
};

export function getDisplayValue(field, value) {
  if (Array.isArray(value)) {
    return value.join(', ');
  }
  switch (field) {
    case 'is_higher_better':
      return value ? 'Higher is better' : 'Lower is better';
    case 'metrics_type':
      return metricTypeMapping[value] ?? value;
    default:
      return deploymentValuesMap[value] ?? convertToString(field, value);
  }
}

export function hasValues(values: any[]) {
  return values.every((value) => isNotNullOrUndefined(value));
}

export const extractWorkflowIdFromUrl = (url: string): string | null => {
  const regex = /\/workflow\/(flow|metric|dimension|rename)\/([^/]+)/;
  const match = url.match(regex);
  return match ? match[2] : null;
};
